import { useEffect } from 'react';
import { ACTIVE_SCHEME } from '@/config/colorSchemes';
import { camelToKebab } from '@/lib/themeUtils';

/**
 * ThemeSynchronizer - Applies the active color scheme to CSS variables
 * 
 * This component ensures that the TypeScript color scheme configuration
 * is the single source of truth by dynamically setting CSS variables
 * on the document root element.
 */
export const ThemeSynchronizer = () => {
  useEffect(() => {
    const root = document.documentElement;
    const colors = ACTIVE_SCHEME.colors;

    // Apply each color as a CSS variable
    Object.entries(colors).forEach(([key, value]) => {
      const cssVarName = `--${camelToKebab(key)}`;
      root.style.setProperty(cssVarName, value);
    });

    console.log('✅ Theme synchronized:', ACTIVE_SCHEME.name);
  }, []); // Run once on mount

  return null; // This component doesn't render anything
};
